import { MetricLibrarySortBy, OrderDirection } from 'webapp/enums/enums';
import { TrackingEvent } from 'webapp/enums/tracking';
import type { SearchProps } from 'webapp/utils/filter';

import FilterSortMetricLibraryMainBase from 'webapp/models-custom/filter-sort/metric-library-main-base';
import type SourceType from 'webapp/models-custom/source-type';

export default class FilterSortMetricLibraryMainIntegrations extends FilterSortMetricLibraryMainBase<SourceType> {
	override searchProps: SearchProps = {
		name: 5,
		description: 3,
		key: 2,
		metricsByPopularityNames: 1,
	};

	override typedFilterEventName = TrackingEvent.DATASOURCE_SEARCH;

	override sortByPopularityValue = 'popularity';
	override sortByAlphabeticallyValue = 'name';

	override categoryFilterFunction(item: SourceType, selected: string) {
		return this.mmSourceTypesService.categoryFilterFunction(item, selected);
	}

	override dataSourceFilterFunction(item: SourceType, selected: string) {
		return item.key.includes(selected);
	}

	override updateSortBy(sortBy: MetricLibrarySortBy): void {
		switch (sortBy) {
			default:
			case MetricLibrarySortBy.POPULARITY:
				this.sortProp = this.sortByPopularityValue;
				this.sortOrder = OrderDirection.ASC;
				break;
			case MetricLibrarySortBy.ALPHABETICALLY: {
				this.sortProp = this.sortByAlphabeticallyValue;
				this.sortOrder = OrderDirection.ASC;
				break;
			}
		}
	}
}
